/* DESPI — overlay de generation, partage par la page produit et la page portrait.
   Expose window.despiOverlay() -> { progresser, terminer, fermer, echouer }.

   Le meme overlay sert a la premiere generation ET aux relances (Retry / Edit) : c'est le
   langage visuel de la marque pour « on peint votre portrait ». Sans lui, une relance se
   lisait comme une page figee — la cliente ne comprenait pas que quelque chose partait.
*/
(function () {
  'use strict';

  function despiOverlay() {
    var quotes = (window.TMR_REVIEWS || []).filter(function (r) {
      return r.img && r.text.length < 120;
    }).slice(0, 8).map(function (r) {
      var parts = r.name.split(' ');
      var short = parts[0] + (parts[1] ? ' ' + parts[1][0] + '.' : '');
      return { name: short, text: r.text, img: r.img };
    });
    if (!quotes.length) quotes = [{ name: 'Emily R.', text: 'Stunning quality.', img: '' }];

    var ov = document.createElement('div');
    ov.className = 'fixed inset-0 z-50 backdrop-blur-[28px] bg-[rgba(5,5,5,0.24)] overflow-hidden tmr-genoverlay';
    ov.innerHTML =
      '<div class="tmr-gen-card">' +
        '<div class="tmr-gen-top">' +
          '<p class="tmr-gen-title">Painting your portrait</p>' +
          '<div class="tmr-gen-bar"><div class="tmr-gen-fill" style="width:0%"></div></div>' +
          '<p class="tmr-gen-pct">0%</p>' +
          '<p class="tmr-gen-eta">~45 seconds remaining</p>' +
        '</div>' +
        '<div class="tmr-gen-review">' +
          '<div class="tmr-gen-slide" data-gen-slide>' +
            '<div class="tmr-gen-imgwrap"><img alt="" data-gen-img></div>' +
            '<div class="tmr-gen-txtcol">' +
              '<div class="tmr-gen-namerow"><span class="tmr-gen-name" data-gen-name></span><span class="tmr-gen-stars">★★★★★</span></div>' +
              '<p class="tmr-gen-quote" data-gen-quote></p>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(ov);
    document.body.style.overflow = 'hidden';

    var slide = ov.querySelector('[data-gen-slide]');
    var qi = 0;
    function applyQuote() {
      var q = quotes[qi % quotes.length];
      ov.querySelector('[data-gen-name]').textContent = q.name;
      ov.querySelector('[data-gen-quote]').textContent = '\u201C' + q.text + '\u201D';
      var im = ov.querySelector('[data-gen-img]');
      im.src = q.img;
      im.alt = q.name;
      qi++;
    }
    applyQuote();
    var quoteTimer = setInterval(function () {
      slide.classList.add('is-out');
      setTimeout(function () {
        applyQuote();
        slide.classList.remove('is-out');
      }, 800);
    }, 4200);

    // Progression PILOTEE PAR L'HORLOGE, pas par le serveur.
    //
    // La version precedente derivait le temps restant du POURCENTAGE. Comme la barre
    // plafonnait, le compte a rebours se figeait avec elle et affichait « ~2 seconds
    // remaining » indefiniment — une promesse que rien ne pouvait plus tenir. Ici les deux
    // sont independants : la barre suit une courbe, le rebours suit la montre.
    //
    // La courbe est un ease-out : elle avance vite au debut (le parcours parait reactif)
    // puis ralentit sans jamais atteindre 100 %, qui est reserve a la vraie fin. Le
    // plafond de 92 % est deliberé — au-dela, chaque pourcent non tenu se paie cher.
    //
    // Quand le budget est epuise, on ne ment pas : le chiffre DISPARAIT et le titre passe
    // a une formule sans promesse. Mieux vaut « on y est presque » sans nombre qu'un
    // nombre faux.
    var BUDGET = (window.DESPI_BUDGET_MS || 45000);
    var PLAFOND = 92;
    var t0 = Date.now();
    var plancher = 0;      // progression minimale imposee par les etapes (upload, etc.)
    var fini = false;
    var affiche = 0;

    function courbe(ms) {
      var t = Math.min(ms / BUDGET, 1);
      return PLAFOND * (1 - Math.pow(1 - t, 2.5));
    }

    var progTimer = setInterval(function () {
      var ecoule = Date.now() - t0;
      var vise = fini ? 100 : Math.min(PLAFOND, Math.max(courbe(ecoule), plancher));
      // on ne recule jamais : une barre qui redescend detruit la confiance
      affiche = Math.max(affiche, vise);
      var p = Math.round(affiche);

      ov.querySelector('.tmr-gen-pct').textContent = p + '%';
      ov.querySelector('.tmr-gen-fill').style.width = p + '%';

      var restant = Math.max(0, Math.round((BUDGET - ecoule) / 1000));
      var eta = ov.querySelector('.tmr-gen-eta');
      if (fini) {
        eta.style.display = '';
        eta.textContent = 'Done';
      } else if (restant > 0) {
        eta.style.display = '';
        eta.textContent = '~' + restant + ' seconds remaining';
      } else {
        eta.style.display = 'none';        // plus de chiffre : plus de promesse
      }

      ov.querySelector('.tmr-gen-title').textContent =
        restant === 0 && !fini ? 'Hang tight, almost there…'
          : p < 35 ? 'Painting your portrait'
          : p < 75 ? 'Adding the finishing touches'
          : 'Your masterpiece almost ready';
    }, 100);

    function fermer() {
      clearInterval(progTimer);
      clearInterval(quoteTimer);
      ov.classList.add('is-closing');
      setTimeout(function () { ov.remove(); document.body.style.overflow = ''; }, 400);
    }

    return {
      // Les appelants signalent leur avancement d'etape ; ca ne fait que RELEVER un
      // plancher, la courbe garde la main. Sans ca, une etape rapide propulserait la
      // barre a 90 % pour la laisser immobile pendant une minute.
      progresser: function (p) { plancher = Math.max(plancher, Math.min(PLAFOND, p)); },
      terminer: function () { fini = true; affiche = 100; },
      fermer: fermer,

      /**
       * Fin en echec. Accepte une simple chaine (ancien usage) ou l'objet rendu par
       * despiMessageErreur().
       *
       * Deux regles apprises a l'usage :
       *  - ne pas annoncer une panne quand il n'y en a pas. Un quota atteint affichait
       *    « Something went wrong », ce qui fait croire a un bug alors que c'est une
       *    limite voulue ;
       *  - quand une action est possible, la PROPOSER. L'overlay se fermait tout seul au
       *    bout de 2,6 s en laissant la cliente devant une page inchangee, sans savoir
       *    quoi faire. Avec un bouton, il reste ouvert : c'est elle qui decide.
       */
      echouer: function (info) {
        if (typeof info === 'string' || !info) info = { msg: info };
        clearInterval(progTimer);
        clearInterval(quoteTimer);
        var eta = ov.querySelector('.tmr-gen-eta');
        ov.querySelector('.tmr-gen-title').textContent = info.titre || 'Something went wrong';
        eta.style.display = '';
        eta.textContent = info.msg || 'Please try again';

        if (typeof info.onAction !== 'function') { setTimeout(fermer, 2600); return; }

        // Styles en ligne volontairement : la CSS du theme est PRE-COMPILEE, toute classe
        // qui n'y figure pas deja est ignoree en silence.
        var zone = document.createElement('div');
        zone.style.cssText = 'display:flex;gap:10px;justify-content:center;margin-top:14px;flex-wrap:wrap';
        var principal = document.createElement('button');
        principal.type = 'button';
        principal.textContent = info.action || 'Try again';
        principal.style.cssText = 'background:#3B3157;color:#fff;border:0;border-radius:999px;'
          + 'padding:12px 22px;font-size:15px;font-weight:600;cursor:pointer;min-height:44px';
        principal.addEventListener('click', function () { fermer(); info.onAction(); });
        var secondaire = document.createElement('button');
        secondaire.type = 'button';
        secondaire.textContent = 'Close';
        secondaire.style.cssText = 'background:transparent;color:#3B3157;border:1px solid rgba(59,49,87,0.35);'
          + 'border-radius:999px;padding:12px 20px;font-size:15px;cursor:pointer;min-height:44px';
        secondaire.addEventListener('click', fermer);
        zone.appendChild(principal);
        zone.appendChild(secondaire);
        ov.querySelector('.tmr-gen-top').appendChild(zone);
        principal.focus();
      },
    };
  }

  /**
   * Traduit une erreur d'API en message lisible par une cliente.
   *
   * Partage par la page produit et la page portrait : sans ca, chaque page avait sa
   * propre liste, et les codes 413 (photo trop lourde) comme 415 (format non gere)
   * n'etaient traduits NULLE PART — la cliente lisait « Please try again », c'est-a-dire
   * une invitation a refaire exactement ce qui vient d'echouer.
   *
   * `action` est le libelle du bouton propose ; la page decide de ce qu'il declenche.
   */
  window.despiMessageErreur = function (e) {
    var code = (e && e.body && e.body.error) || '';
    var statut = e && e.status;
    if (code === 'no_subject') {
      return { titre: 'We could not find anyone', msg: 'No face detected on this photo', action: 'Choose another photo' };
    }
    if (statut === 413) {
      return { titre: 'This photo is too large', msg: 'Please pick a smaller one', action: 'Choose another photo' };
    }
    if (statut === 415) {
      return { titre: 'Format not supported', msg: 'Use a JPEG, PNG or HEIC photo', action: 'Choose another photo' };
    }
    if (statut === 410 || statut === 404) {
      return { titre: 'This portrait has expired', msg: 'Start again with your photo', action: 'Start over' };
    }
    if (statut === 504) {
      // le sondage a renonce : soit la generation traine anormalement, soit le reseau est
      // coupe. Dans les deux cas on propose de relancer plutot que de laisser la page morte.
      return { titre: 'This is taking longer than expected', msg: 'Check your connection and try again', action: 'Try again' };
    }
    if (statut === 422 || code === 'cart_add_refuse') {
      return { titre: 'We could not add this to your cart', msg: 'Please try again in a moment', action: 'Try again' };
    }
    if (statut === 402) {
      /* Ce n'est pas une panne, et le quota revient DEMAIN : on le dit, sinon la cliente
         croit la porte fermee pour toujours. Ses portraits deja crees restent accessibles. */
      return {
        titre: "That's 20 portraits today",
        msg: 'You have used all 20 free previews for today — they reset tomorrow. Your portraits are still saved, and you can order any of them right now.',
      };
    }
    if (statut === 429) {
      /* Plus aucun plafond par adresse : ce code ne peut venir que du plafond QUOTIDIEN de
         la boutique. C'est notre limite a nous, pas une faute de la cliente — on ne lui
         demande donc pas de « reessayer », on lui ouvre une porte humaine. */
      return {
        titre: 'We are at capacity today',
        msg: 'We have hit our daily limit of portraits. Please come back tomorrow, or email support@trydespi.com and we will make yours by hand.',
      };
    }
    return { titre: 'Something went wrong', msg: 'Please try again' };
  };

  window.despiOverlay = despiOverlay;
})();
